import React, { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import PlainCheckbox from '../../../PlainCheckbox';
import PlainRadioButton from '../../../PlainRadioButton';
import { useSelectionBox } from '../context';

import styles from './SelectionBoxControl.module.scss';

const SelectionBoxControl = ({ value }) => {
  const { selected, hideSelectionControl, selectionType } = useSelectionBox();

  const isActive = useMemo(() => {
    if (selectionType === 'radio') {
      return value === selected;
    } else if (selectionType === 'checkbox') {
      return selected.includes(value);
    }
  }, [value, selected, selectionType]);

  if (hideSelectionControl || !selectionType) {
    return null;
  }

  return (
    <div
      className={cx(styles.container, {
        [styles.active]: isActive,
      })}
      role={selectionType}
    >
      {selectionType === 'radio' && (
        <PlainRadioButton readOnly checked={isActive} />
      )}
      {selectionType === 'checkbox' && (
        <PlainCheckbox readOnly checked={isActive} />
      )}
    </div>
  );
};

SelectionBoxControl.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

export default SelectionBoxControl;
